import $ from "jquery";
// get #section-ISI
$(() => {
  const isiSection = $("#section-ISI");

  isiSection.each((index, element) => {
    const second = $(".second-content", element).clone();
    // add container class
    second.addClass("container d-lg-none");
    second.removeClass("d-none d-lg-block");
    // insert inside #second-title
    const secondTitle = $(".second-title", element);
    secondTitle.append(second);

    // region #section-ISI
    // Lets make the element sticky
    // clone the element and add it to the body
    const clonedElement = $(element).clone();
    // remove the id attribute to avoid duplicate ids
    clonedElement.removeAttr("id");
    $("body").append(clonedElement);
    const height = "150px";
    clonedElement.css({
      position: "fixed",
      bottom: 0,
      left: 0,
      height,
      right: 0,
      zIndex: 2000,
    });
    // add cloned class
    clonedElement.addClass("cloned");

    // add a button to scroll to the original element
    $("a[data-button]", element).each((index, button) => {
      $("span", button).text($(button).data("button"));
      $(button).attr("href", `#`);
    });

    const options = { rootMargin: `0px 0px -${height} 0px` };

    // use IntersectionObserver to check if the element is in view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isBelowFooter = entry.boundingClientRect.y < 0;
        clonedElement.toggleClass(
          "d-none",
          entry.isIntersecting || isBelowFooter
        );
      });
    }, options);

    // start observing the element
    observer.observe(element);
  });
});
